let AbstractExporter = require('../../io/export/abstractExporter');

/**
 * Класс JsonExporter
 * @extends AbstractExporter
 */
class JsonExporter extends AbstractExporter {
  constructor(params){
    super(params);
  }
}

module.exports = JsonExporter;